export default __webpack_public_path__ + "static/solutions-2-d73df87ab4912bd7e2eddf45fc8838e1.webp";